import React from "react";
import { Paper } from "@material-ui/core";
import TitleBox from "../components/common/TitleBox";
import PrmForm from "../components/PrmUpdate/PrmForm";
import { useHistory } from "react-router-dom";

export default function PrmUpdate(props) {
  const { passenger } = props.location.state;
  const history = useHistory();

  const handleSavePress = () => {
    //TODO: Chiamata UPDATE_PRM
    history.goBack();
  };

  return (
    <Paper square elevation={0}>
      <TitleBox title={"Modulo Aggiornamento PRM"} />
      <PrmForm
        isCreate={false} //Distingue fase di aggiornamento da fase di creazione
        onSavePress={() => handleSavePress()}
        passenger={passenger}
      />
    </Paper>
  );
}
